import React from "react";
import './App.css';

const Item = ({ index, color, isClick, setClick }) => {
  return (
    <div
      style={{
        display: "flex",
        flexDirection:"column",
        alignItems: "center",
        justifyContent: "center",
        height: "20%",
        maxWidth: '100%',
        backgroundColor: color,
      }}
    >
      <h1>{`Item ${(index + 1) * 20}%`}</h1>
      {!isClick && index === 2 && <button onClick={()=>setClick(true)}>100vh</button>}
      {isClick && index === 2 && <button onClick={()=>setClick(false)}>calc(var(--vh, 1vh) * 100)</button>}
    </div>
  );
}
const arr = ['orange', 'pink', 'green', 'red', 'yellow'];

function App() {
  const [isClick, setClick] = React.useState(false);

  let windowInnerHeight = 0;
  let vh = 0;

  React.useEffect(() => {
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  });

  const handleResize = () => {
    const currentInnerHeight = window.innerHeight;
    if (currentInnerHeight !== windowInnerHeight) {
      windowInnerHeight = currentInnerHeight;
      vh = window.innerHeight * 0.01;
      document.documentElement.style.setProperty('--vh', `${vh}px`);
    }
  }
  handleResize();

  return (
    <div
      style={{
        height: "100vh",
        height: !isClick ? "calc(var(--vh, 1vh) * 100)" : "100vh",
        maxWidth: "100%",
        "&.-webkit-scrollbar": { display: "none" }
      }}
    >
      <Item key={0} index={0} color={arr[0]} />
      <Item key={1} index={1} color={arr[1]} />
      <Item key={2} index={2} color={arr[2]} isClick={isClick} setClick={setClick} />
      <Item key={3} index={3} color={arr[3]} />
      <Item key={4} index={4} color={arr[4]} />
      {/*arr.map((item, index) => {
        return 
      })*/}
    </div>
  );
}

export default App;
